
import { useEffect, useState } from 'react';
// import Table from '@mui/material/Table';
import {Table, Switch} from 'antd';
import {  HolderOutlined, SyncOutlined} from '@ant-design/icons';

import moment from 'moment';
import EarnContentEditModal from './EarnContentEditModal';
import ReactDragListView from 'react-drag-listview'; 
import 'antd/dist/reset.css';
import './CustomizeTable.css'; // import custom CSS
import { Tooltip } from '@mui/material';





function EarnContentTable(props) {
    const {tableDataList} = props;
    const [tableList, setTableList] = useState([]);

  

    useEffect(()=> {
      const newData =  tableDataList.map((item => {
        return {...item, Offer_Activation_Date: moment(Date(item.Offer_Activation_Date)).format("DD/MM/YYYY hh:mm A")}
      }));
      
      setTableList(newData.slice(0,10));
    },[tableDataList, tableDataList.length]);
   

    const columns = [
      {
        title: 'Drag',
        dataIndex: 'drag',
        key: 'drag',
        render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
      },
      {
        title: "Ref_No",
        dataIndex: "Ref_No",
        // sorter: (a, b) => a.Ref_No.localeCompare(b.Ref_No)
      },
    
      {
        title: "Title",
        dataIndex: "Earn_Title",
        sorter: (a, b) => a.Earn_Title.localeCompare(b.Earn_Title)
      },
      {
        title: "Description",
        dataIndex: "Earn_Description",
      },
    
      {
        title: "Start date",
        dataIndex: "Offer_Activation_Date",
        sorter: (a, b) => a.Offer_Activation_Date.localeCompare(b.Offer_Activation_Date)
      },
    
      {
        title: "Sequence",
        dataIndex: "Display_Sequence",
        // sorter: (a, b) => a.Display_Sequence.localeCompare(b.Display_Sequence)
      },
    
      {
        title: "Status",
        dataIndex: "Earn_Status_Name",
        sorter: (a, b) => a.Earn_Status_Name.localeCompare(b.Earn_Status_Name)
      },

      {
        title: 'Toggle',
        dataIndex: 'toggle',
        key: 'toggle',
        render: (toggle, record) => (
          <Switch
            checked={toggle || record?.Earn_Status_Id === 1}
            onChange={(checked) => handleToggleChange(checked, record)}
          />
        ),
      },
      {
        title: 'Actions',
        dataIndex: 'actions',
        key: 'actions',
        render: (text, record) => (
          <div>
             <EarnContentEditModal item={record} />
            {/* <Button type="link" icon={<EditOutlined style={{ fontSize: '20px' }} />} onClick={() => handleEdit(record)} /> */}
        
          </div>
        ),
      },
    
    
    ];


    const handleToggleChange = (checked, record) => {
      const newStatus = (checked === true) ? 1: 2;
      record.status_id =  newStatus;
      props.changeEarnStatus(checked, record);
    };





const handleDragEnd = (fromIndex, toIndex) => {
  const newData = [...tableList];
    let toItem = newData[toIndex];
    let fromItem = newData[fromIndex];
    let fromSeq = fromItem?.Display_Sequence;
    let toSeq = toItem?.Display_Sequence;
    fromItem['Display_Sequence'] = toSeq;
    toItem['Display_Sequence'] = fromSeq;
    newData[fromIndex] =  toItem;
    newData[toIndex] =  fromItem;
  setTableList(newData);
};

const dragProps = {
  onDragEnd: handleDragEnd,
  handleSelector: ".ant-table-row",
};


const paginationOptions = {
  pageSize: 10,
  showSizeChanger: true,
  total: tableList.length,
  // onChange: (page, pageSize) => {
  //   const newList = tableDataList.slice(0, pageSize);
  //   setTableList(newList);
  // },
};


   

    return ( 
        <>
         <ReactDragListView {...dragProps}>
         {/* <DragOutlined style={{ marginRight: '8px' }} /> */}
         {/* <button>Sync sequence</button> */}
         <Tooltip title="Sync table sequence" className='show-cursor'>
         <SyncOutlined onClick={()=> props.syncTableSequence(tableList)} style={{ fontSize: '20px', color: 'blue'}} />
         </Tooltip>
        <Table key={tableList?.length} columns={columns} dataSource={tableList}
        pagination={paginationOptions}
         style={{ background: '#f0f2f5', borderRadius: '8px' }} />
      </ReactDragListView>
    
      
    
        </>
     );
}

export default EarnContentTable;